/* Galeria pełnoekranowa dla miniatur w hero.

   Miniatury są w markupie zwykłymi linkami do pliku zdjęcia — bez JS
   klik po prostu otwiera obrazek. Ten komponent przechwytuje klik
   i podmienia go na natywny <dialog>, który za darmo daje pułapkę focusa,
   zamykanie Escape i tło modalne. */

class BjLightbox extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-bj-viewer]');
    this.full = this.querySelector('[data-bj-full]');
    this.thumbs = Array.from(this.querySelectorAll('[data-bj-thumb]'));
    if (!this.dialog || !this.full || this.thumbs.length === 0) return;

    // Bez showModal() (starsze Safari) zostawiamy linki tak, jak są.
    if (typeof this.dialog.showModal !== 'function') return;

    this.counter = this.querySelector('[data-bj-counter]');
    this.prev = this.querySelector('[data-bj-prev]');
    this.next = this.querySelector('[data-bj-next]');
    this.index = 0;
    this.opener = null;

    this.onThumbClick = (event) => {
      // Ctrl/Cmd/środkowy przycisk — użytkownik chce nową kartę, nie galerię.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      this.open(this.thumbs.indexOf(event.currentTarget));
    };
    this.thumbs.forEach((thumb) => thumb.addEventListener('click', this.onThumbClick));

    this.onPrev = () => this.show(this.index - 1);
    this.onNext = () => this.show(this.index + 1);
    this.prev?.addEventListener('click', this.onPrev);
    this.next?.addEventListener('click', this.onNext);

    this.onClose = () => this.dialog.close();
    this.querySelector('[data-bj-close]')?.addEventListener('click', this.onClose);

    this.onKeydown = (event) => {
      if (event.key === 'ArrowLeft') this.show(this.index - 1);
      if (event.key === 'ArrowRight') this.show(this.index + 1);
    };
    this.dialog.addEventListener('keydown', this.onKeydown);

    // Klik w tło (::backdrop trafia w sam element <dialog>) zamyka galerię.
    this.onBackdrop = (event) => {
      if (event.target === this.dialog) this.dialog.close();
    };
    this.dialog.addEventListener('click', this.onBackdrop);

    this.onDialogClose = () => this.opener?.focus();
    this.dialog.addEventListener('close', this.onDialogClose);

    if (this.thumbs.length < 2) {
      this.querySelector('[data-bj-nav]')?.setAttribute('hidden', '');
    }
  }

  disconnectedCallback() {
    this.thumbs?.forEach((thumb) => thumb.removeEventListener('click', this.onThumbClick));
    this.prev?.removeEventListener('click', this.onPrev);
    this.next?.removeEventListener('click', this.onNext);
    this.dialog?.removeEventListener('keydown', this.onKeydown);
    this.dialog?.removeEventListener('click', this.onBackdrop);
    this.dialog?.removeEventListener('close', this.onDialogClose);
  }

  open(index) {
    if (index < 0) return;
    this.opener = this.thumbs[index];
    this.show(index);
    this.dialog.showModal();
  }

  show(index) {
    // Zawijanie na obu końcach — z ostatniego zdjęcia wracamy na pierwsze.
    const count = this.thumbs.length;
    this.index = ((index % count) + count) % count;

    const thumb = this.thumbs[this.index];
    this.full.src = thumb.getAttribute('href');
    this.full.alt = thumb.dataset.bjAlt || '';
    if (this.counter) this.counter.textContent = `${this.index + 1} / ${count}`;
  }
}

customElements.define('bj-lightbox', BjLightbox);
